import { useState } from "react";

import { PublicationListData } from "@/components/business/PublicationListContainer/publicationList.types";
import { ProcessStatusCode } from "@/types/code.types";
import useModal from "@hooks/useModal";

import ListCheckStatusGuide from "./components/ListTableShellForTitle/components/CheckStatusGuide/CheckStatusGuide";
import ListTableShellForTitle from "./components/ListTableShellForTitle/ListTableShellForTitle";
import ListGuideModal from "../LIstGuideModal/ListGuideModal";
import ListPageEntryGuide from "../ListPageEntryGuide/ListPageEntryGuide";

type Props = {
  listItem: PublicationListData;
  updatePublicationList: () => void;
  ListData: PublicationListData[];
};

const PublicationTitleContainer = ({
  updatePublicationList,
  listItem,
  ListData,
}: Props) => {
  const [targetId, setTargetId] = useState("");
  const [currentStatus, setCurrentStatus] = useState<ProcessStatusCode | "">(
    "",
  );

  const { isModal, closeModal, openModal } = useModal();
  const {
    isModal: isGuideModal,
    closeModal: closeGuideModal,
    openModal: openGuideModal,
  } = useModal();
  const {
    isModal: isCheckStatusModal,
    closeModal: closeCheckStatusModal,
    openModal: openCheckStatusModal,
  } = useModal();

  const handleTargetId = (id: string) => {
    setTargetId(id);
  };

  const handleCurrentStatus = (status: ProcessStatusCode | "") => {
    setCurrentStatus(status);
  };

  const openAccessDeniedModal = (id: string) => {
    handleTargetId(id);
    openGuideModal();
  };

  const openConcurrentAccessDeniedModal = (id: string) => {
    handleTargetId(id);
    openModal();
  };

  return (
    <>
      <ListTableShellForTitle
        key={listItem.publicationId}
        publicationData={listItem}
        openCheckStatusModal={openCheckStatusModal}
        openAccessDeniedModal={() =>
          openAccessDeniedModal(listItem?.publicationId || "")
        }
        openConcurrentAccessDeniedModal={() =>
          openConcurrentAccessDeniedModal(listItem?.publicationId || "")
        }
        handleTargetCtgId={() => handleTargetId(listItem?.publicationId || "")}
        handleCurrentStatus={handleCurrentStatus}
      />

      {isModal && (
        <ListPageEntryGuide
          closeModal={closeModal}
          updateList={updatePublicationList}
        />
      )}

      {isGuideModal && (
        <ListGuideModal
          closeModal={closeGuideModal}
          draftArticleId={Number(targetId)}
        />
      )}

      {isCheckStatusModal && (
        <ListCheckStatusGuide
          closeModal={closeCheckStatusModal}
          draftArticleId={Number(targetId)}
          updatePublicationList={updatePublicationList}
          publicationListData={ListData || []}
          openAccessDeniedModal={openGuideModal}
          openConcurrentAccessDeniedModal={openModal}
          currentStatus={currentStatus}
        />
      )}
    </>
  );
};

export default PublicationTitleContainer;
